/** clear versions number for snapshot tests */
function clearVersions(dto) {
    if (dto.versions) {
        let k;
        for (k in dto.versions) {
            if (Object.prototype.hasOwnProperty.call(dto.versions, k)) {
                dto.versions[k] = '0.0.0';
            }
        }
    }
}

export { clearVersions };
//# sourceMappingURL=clear-versions.js.map
